import React from "react";
import { Input } from "../Input";
import { Button } from "../Button";
import { connect } from "react-redux";
import language from "../../language";
import { getStorage } from "../../utils/storage";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import icons from "../../constants/icons";
import validateEmail from "../../utils/validateEmail";
import validatePhoneNumber from "../../utils/validatePhoneNumber";
import { saveProfileUnits } from "../../actions/ProfileUnits";
import api from "../../utils/api";

class NewDirector extends React.Component {
  state = {
    error: {},
    name: "",
    email: "",
    phoneNumber: "",
    isSubmitting: false,
  };

  componentDidMount() {
    if (this.props.id) {
      this.setState({
        ...this.props,
      });
    }
  }

  onChangeInput(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      error,
      [field]: e.target ? e.target.value : e,
    });
  }

  validateForm() {
    let { error, name, email, phoneNumber } = this.state;

    console.log(validateEmail(email));

    if (name === "") {
      error.name = language[this.props.defaultLanguage].name_required;
    }

    if (email === "") {
      error.email = language[this.props.defaultLanguage].email_required;
    } else if (!validateEmail(email)) {
      error.email = language[this.props.defaultLanguage].invalid_email;
    }

    if (phoneNumber === "") {
      error.phoneNumber = language[this.props.defaultLanguage].phone_required;
    } else if (!validatePhoneNumber(phoneNumber)) {
      error.phoneNumber =
        language[this.props.defaultLanguage].invalid_phone_number;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    let { error, name, email, phoneNumber } = this.state;
    const { id } = this.props;

    let user = await getStorage();

    if (Object.keys(error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      const options = {
        method: "POST",
        url: `${api("profile")}/contact`,
        data: {
          name,
          email,
          phoneNumber,
          contactId: id || "",
        },
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + user.accessToken,
        },
      };

      axios(options)
        .then((data) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage][
              id && id !== ""
                ? "contact_update_success"
                : "contact_added_success"
            ]
          );

          this.props.getData();
          this.props.handleCloseModal();
          this.handleUpdateProfileUnitsStorage("CONTACT");
        })
        .catch((error) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage][
              id && id !== "" ? "contact_update_error" : "contact_added_error"
            ]
          );
        });
    }
  };

  handleUpdateProfileUnitsStorage = async (unit) => {
    const { profileUnits } = this.props;

    const modifiedUnits = profileUnits?.map((el) => {
      if (el.unit === unit && !el.provided) {
        el.provided = true;
      }

      return el;
    });

    await this.props.dispatch(saveProfileUnits(modifiedUnits));
  };

  render() {
    return (
      <>
        <div className="card-body">
          <Input
            label={language[this.props.defaultLanguage].name}
            placeholder={language[this.props.defaultLanguage].name_placeholder}
            value={this.state.name}
            onChange={(e) => this.onChangeInput("name", e)}
            error={this.state.error.name}
            leftIcon={icons.user}
          />
          <Input
            label={language[this.props.defaultLanguage].email_address}
            placeholder={language[this.props.defaultLanguage].email_placeholder}
            value={this.state.email}
            onChange={(e) => this.onChangeInput("email", e)}
            error={this.state.error.email}
            leftIcon={icons.email}
          />
          <Input
            label={language[this.props.defaultLanguage].phone_number}
            placeholder={language[this.props.defaultLanguage].phone_placeholder}
            value={this.state.phoneNumber}
            onChange={(e) => this.onChangeInput("phoneNumber", e)}
            error={this.state.error.phoneNumber}
            leftIcon={icons.phone}
            type="number"
          />
        </div>
        <div className="modal-footer">
          <Button
            type="link"
            className="btn-transparent"
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
          />
          <Button
            text={language[this.props.defaultLanguage].submit}
            isSubmitting={this.state.isSubmitting}
            onPress={this.onSubmit.bind(this)}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { profileUnits } = state.ProfileUnits;
  return {
    defaultLanguage,
    profileUnits,
  };
};

export default connect(mapStateToProps)(NewDirector);
